





































































import { doLogin, verifyLoginCode } from "@/services/login.service";
import axios from "axios";
import { availableLanguages } from "@/services/translate.service";
import LanguageSelector from "@/components/LanguageSelector.vue";
import { APP_VERSION } from "@/version";

export default {
  data() {
    return {
      appVersion: APP_VERSION,
      formEmail: "",
      formLang: "de",
      formPwd: "",
      error: false,
      errorMessage: "",
      languages: [],
      step: "credentials",
      challengeId: "",
      formCode: "",
      attemptsLeft: null,
      loading: false,
    };
  },
  watch: {
    formLang: function (val) {
      this.$i18n.locale = val
    },
  },

  methods: {
    login: function () {
      if (this.loading) return;
      this.loading = true;

      this.error = false;
      this.attemptsLeft = null;

      this.$store.commit("auth_request");

      doLogin({ email: this.formEmail, password: this.formPwd, lang: this.$i18n.locale }).then((x) => {
        console.log(x);
        if (x.status === "2fa_required") {
          this.challengeId = x.challengeId;
          this.formCode = "";
          this.step = "code";
          return;
        }
        if (x.status == "error") {
          this.error = true;
          this.errorMessage = x.message;
          this.$store.commit("auth_error");
          localStorage.removeItem("token");
          return;
        }
        this.applyLogin(x.data);
      }).catch((e) => {
        const err = e || {};
        const response = err.response || {};
        if (response.status === 429) {
          // Backend liefert die lokalisierte TOO_MANY_REQUESTS-Message im 429-Body.
          this.errorMessage = (response.data && response.data.message) || this.$t("RESET_GENERIC_ERROR");
        } else {
          this.errorMessage = this.$t("RESET_GENERIC_ERROR");
        }
        this.error = true;
        this.$store.commit("auth_error");
      }).finally(() => {
        this.loading = false;
      });
    },

    verifyCode: function () {
      if (this.loading) return;
      this.loading = true;

      this.error = false;
      this.attemptsLeft = null;

      verifyLoginCode(this.challengeId, this.formCode, this.$i18n.locale).then((x) => {
        console.log("verifyLoginCode response", x);
        if (x.status === "success") {
          if (!x.data || !x.data.token) {
            console.error("[verifyCode] success ohne data.token", x);
            this.error = true;
            this.errorMessage = "Login-Antwort unvollständig (token fehlt). Bitte Screenshot an den Support.";
            return;
          }
          this.applyLogin(x.data);
          return;
        }
        this.error = true;
        this.errorMessage = x.message;
        if (typeof x.attemptsLeft === "number") {
          this.attemptsLeft = x.attemptsLeft;
        }
        if (x.attemptsLeft === 0 || /erneut anmelden/i.test(x.message || "")) {
          this.step = "credentials";
          this.formCode = "";
        }
      }).catch((e) => {
        console.error("[verifyCode] exception", e);
        const err = e || {};
        const response = err.response || {};
        const httpStatus = response.status;
        const httpData   = response.data || {};
        this.error = true;
        this.errorMessage =
          "Verifikation fehlgeschlagen.\n" +
          "HTTP-Status: " + (httpStatus || "(keiner)") + "\n" +
          "Nachricht: " + (err.message || httpData.message || "Unbekannter Fehler");
      }).finally(() => {
        this.loading = false;
      });
    },

    resendCode: function () {
      this.step = "credentials";
      this.formCode = "";
      this.attemptsLeft = null;
      this.login();
    },

    applyLogin: function (data) {
      const token = data.token;
      const user = data.user;
      const role = data.role;
      const company_id = data.company_id;

      this.$store.state.user_role = role;
      localStorage.setItem("user_role", JSON.stringify(role));
      this.$store.state.company_id = company_id;
      localStorage.setItem("company_id", company_id);

      this.$store.state.lang = this.formLang
      console.log('lang', this.$store.state.lang);

      axios.defaults.headers.common['x-lang'] = this.$store.state.lang

      localStorage.setItem("lang", this.formLang);

      localStorage.setItem("token", token);
      axios.defaults.headers.common["x-access-token"] = token;
      this.$store.commit("auth_success", { token, user });
      // Das Verdikt zum Glossar gehoert nicht in die Login-Antwort: es kommt
      // aus `/checklist/glossary/permission` und gilt nur fuer diese Sitzung.
      // Beim App-Start holt `App.vue` es; hier, weil dessen `mounted` nach dem
      // Login nicht erneut laeuft.
      this.$store.dispatch("glossary_permission_reload");
      this.$router.push({ name: "overview" });
    },

    onLanguageChanged(language: any) {
      this.formLang = language.locale;
      console.log('onLanguageChanged', language);
    },

    keyUp: function (ev) {
      if (ev.keyCode == 13) {
        this.login();
      }
    },
  },
  mounted() {
    const languages = availableLanguages();
    console.log('i18n', this.$i18n.availableLocales);
    languages.forEach(l => {
      this.languages.push({ name: this.$i18n.t(l), locale: l },)

    });
    console.log('mounted', languages, this.languages);

  },
  components: {
    LanguageSelector
  }

};
